import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🧱", key: "alwaysUpToDate" },
  { emoji: "🦾", key: "everythingEasyToFind" },
  { emoji: "⚙️", key: "editAnytime" },
  { emoji: "🛡️", key: "lessStress" },
]

export default function CarsFutureOutcomePage() {
  return (
    <RadioCardListPage translationKey="carsFutureOutcome" options={OPTIONS} />
  )
}
